import LegalPage, { Section } from './components/LegalPage';

// Static page — no data, no state. Linked from the footer of every page.
const LAST_UPDATED = 'August 24, 2026';

function Terms() {
  return (
    <LegalPage title="Terms of Service" lastUpdated={LAST_UPDATED}>
      <Section title="1. Acceptance of these terms">
        <p>
          Dissona (&ldquo;the Service&rdquo;) is operated as a personal project. By creating an
          account, uploading content, or otherwise using the Service, you agree to these Terms
          of Service. If you do not agree with them, please do not use the Service.
        </p>
        <p>
          These terms may be updated from time to time. Continued use of the Service after a
          change takes effect constitutes acceptance of the revised terms.
        </p>
      </Section>

      <Section title="2. Your account">
        <p>
          You are responsible for maintaining the confidentiality of your account credentials
          and for all activity that occurs under your account. Please keep your contact details
          accurate, and notify us promptly of any unauthorised use.
        </p>
      </Section>

      <Section title="3. Your content and copyright">
        <p>
          You retain ownership of the documents, text, and other material you upload
          (&ldquo;Your Content&rdquo;). You are solely responsible for it.
        </p>
        <p>
          By uploading Your Content, you represent and warrant that you own it or otherwise hold
          all rights necessary to upload it and to have it processed into audio, and that doing
          so does not infringe the copyright, privacy, or other rights of any third party. Do
          not upload material you are not entitled to use.
        </p>
        <p>
          You grant us a limited licence to store, process, and transmit Your Content solely for
          the purpose of operating the Service for you — including generating audio from it and
          delivering it to you and to anyone you explicitly share it with. We claim no ownership
          of Your Content. We may remove content that we reasonably believe violates these terms
          or applicable law.
        </p>
      </Section>

      <Section title="4. Acceptable use">
        <p>
          Do not use the Service to upload or distribute unlawful material, to infringe the
          rights of others, to attempt to gain unauthorised access to the Service or its
          infrastructure, or to interfere with its operation or with other users. We may suspend
          or terminate accounts that do.
        </p>
      </Section>

      <Section title="5. Service provided &ldquo;as is&rdquo;">
        <p>
          The Service is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis,
          without warranties of any kind, whether express or implied, including but not limited
          to warranties of merchantability, fitness for a particular purpose, accuracy, and
          non-infringement.
        </p>
        <p>
          We make no guarantee that the Service will be available, uninterrupted, secure, or
          error-free, that generated audio will meet your expectations, or that your data will be
          preserved. Keep your own copies of anything you cannot afford to lose. The Service may
          be modified, suspended, or discontinued at any time without notice.
        </p>
      </Section>

      <Section title="6. Limitation of liability">
        <p>
          To the fullest extent permitted by applicable law, the operator of the Service shall
          not be liable for any indirect, incidental, special, consequential, or exemplary
          damages, nor for any loss of data, revenue, profits, or goodwill, arising out of or in
          connection with your use of — or inability to use — the Service, regardless of the
          legal theory on which the claim is based and even if advised of the possibility of
          such damages.
        </p>
        <p>
          To the extent that liability cannot be excluded, it is limited to the greater of the
          amount you paid for the Service in the twelve months preceding the claim, or ten euros
          (&euro;10).
        </p>
      </Section>

      <Section title="7. Indemnity">
        <p>
          You agree to indemnify and hold harmless the operator of the Service against any
          claims, damages, liabilities, and expenses arising from Your Content or from your use
          of the Service in breach of these terms.
        </p>
      </Section>

      <Section title="8. Termination">
        <p>
          You may stop using the Service and delete your account at any time. We may suspend or
          terminate access if these terms are breached. Sections 3 and 5 through 7 survive
          termination.
        </p>
      </Section>

      <Section title="9. Governing law">
        <p>
          These terms are governed by the laws of the Republic of Bulgaria, without regard to
          its conflict-of-law rules. Nothing here limits any statutory rights you may have as a
          consumer that cannot be waived by agreement.
        </p>
      </Section>
    </LegalPage>
  );
}

export default Terms;
